import * as React from "react";
const SvgSessions = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="sessions_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path
      fill="#1B213F"
      d="M282.24 988.16a37.76 37.76 0 0 0 17.92 3.84 42.24 42.24 0 0 0 19.84-4.48l229.12-132.48A51.84 51.84 0 0 0 576 811.52V650.88a44.8 44.8 0 0 0-18.56-33.28 44.8 44.8 0 0 0-38.4 0L288 750.72a51.84 51.84 0 0 0-24.96 43.52v160.64a38.4 38.4 0 0 0 19.2 33.28zM512 696.32v108.16l-184.96 105.6V801.92zM280.96 704a37.76 37.76 0 0 0 17.92 3.84A42.24 42.24 0 0 0 320 704l229.12-135.68A51.84 51.84 0 0 0 576 524.8V364.16a44.8 44.8 0 0 0-18.56-33.28 44.8 44.8 0 0 0-38.4 0L286.72 464a51.84 51.84 0 0 0-24.96 43.52v160.64a38.4 38.4 0 0 0 19.2 35.84zM512 408.96v108.16l-185.6 105.6V512zm-213.76 8.96a42.24 42.24 0 0 0 21.76-4.48l227.84-132.48A51.84 51.84 0 0 0 576 238.08V77.44a44.8 44.8 0 0 0-22.4-33.28 44.8 44.8 0 0 0-38.4 0L286.08 176.64a51.84 51.84 0 0 0-24.96 43.52V384a37.76 37.76 0 0 0 18.56 33.28 37.12 37.12 0 0 0 18.56.64zM508.8 122.24v107.52l-183.04 105.6V228.48zm104.32 549.12a16 16 0 0 0 21.76 5.76l94.72-54.4a33.92 33.92 0 0 0 17.28-29.44v-512a28.8 28.8 0 0 0-12.8-29.44A28.8 28.8 0 0 0 704 51.2l-87.04 49.92A16 16 0 0 0 633.6 128l80-46.08v512l-94.72 54.4a16 16 0 0 0-5.76 23.04z"
    />
  </svg>
);
export default SvgSessions;
